export const normalizeString = (str = '') =>
  str.replace(/\W/gi, '-').toLowerCase();
